export default __webpack_public_path__ + "static/media/FabricUpholsteryFeltMilled001_AO_3K.4e3acbf0.jpg";